<script setup>
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
import MissionVisionComponent from "@/Components/Frontend/Home/MissionVisionComponent.vue";
defineProps(["hero_text", "mission_vision"]);
</script>
<template>
    <section class="text-gray-600">
        <div
            class="container 2xl:px-56 xl:px-16 lg:pt-32 sm:pt-20 pt-20 mx-auto"
        >
            <div class="flex flex-wrap">
                <div
                    class="lg:w-1/2 md:w/2 md:mx-auto lg:pl-6 pt-4 bg-white lg:hidden block">
                    <div class="">
                        <!-- <img
                            :src="hero_text?.image"
                            :alt="hero_text?.heading"
                            class="object-cover object-center inline-block bg-white w-full h-full sm:w-64 sm:h-full md:w-full md:h-64 lg:w-96 lg:h-80"
                        /> -->

                        <img
                            :src="hero_text.image"
                            :alt="hero_text?.heading"
                            width="300"
                            height="auto"
                            decoding="async"
                            fetchpriority="high"
                            class="object-cover object-center"
                        />
                    </div>
                </div>
                <div
                    class="lg:w-1/2 lg:mb-0 p-4 lg:mt-0 mt-4 wow animate__animated animate__fadeInLeft"
                >
                    <div>
                        <h1
                            class="text-black font-medium 2xl:text-[45px] xl:text-[42px] lg:text-[36px] text-[24px] leading-tight uppercase"
                        >
                            <span class="text-[#0094A1] sm:text-[#1CBED1]">{{
                                locale === "BN"
                                    ? hero_text?.bn_heading
                                    : hero_text?.heading
                            }}</span>
                            {{
                                locale === "BN"
                                    ? hero_text?.bn_sub_heading
                                    : hero_text?.sub_heading
                            }}
                        </h1>
                        <div class="flex flex-col md:flex-row">
                            <div class="text-justify">
                                <p
                                    class="sm:mt-8 mt-4 text-black sm:text-[18px] text-base leading-relaxed"
                                    v-html="
                                        locale === 'BN'
                                            ? hero_text?.bn_content
                                            : hero_text?.content
                                    "
                                ></p>
                            </div>
                        </div>
                    </div>

                    <mission-vision-component
                        :mission_vision="mission_vision"
                    />
                </div>

                <div
                    class="lg:w-1/2 md:w/2 md:mx-auto lg:pl-6 pt-4 bg-white hidden lg:block wow animate__animated animate__fadeInRight"
                >
                    <div class="">
                        <img
                            :src="hero_text.image"
                            :alt="hero_text?.heading"
                            width="500"
                            height="auto"
                            decoding="async"
                            fetchpriority="high"
                            class="object-cover object-center"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
